import http from "../../Services/Auth/config/http-common";
import ICatRutas from "../../Interfaces/Catalogos/ICatRutas";
import IRespuesta from "../../Interfaces/Respuestas/IRespuesta";
import DTOCatRutas from "../../DTOs/Catalogos/DTOCatRutas";

class CatRutasDataService {
  Get() {
    return http.get<DTOCatRutas[]>("Catalogos/CatRutas/Get");
  }
  Append(data: ICatRutas) {
    return http.post<ICatRutas>(`Catalogos/CatRutas/Append`,data);
  }
  Delete(id: number) {
    return http.delete<IRespuesta>(`Catalogos/CatRutas/Delete/${id}`);
  }
}
export default new CatRutasDataService();